<template>
  <div
    class="flex flex-direction justify-center align-center login-container min-body-height"
  >
    <el-card
      :class="
        (UI.isMobile ? 'full-item' : 'margin-50') +
          ' ' +
          (UI.clientHeight < 800 ? 'scroll-y' : '')
      "
    >
      <div slot="header" class="clearfix">
        <span>注册</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="toLogin()"
        >
          登录
        </el-button>
      </div>
      <Register
        :class="UI.isMobile ? 'mobile-login-box' : 'login-box'"
      ></Register>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Register from './register.vue';

export default {
  components: {
    Register,
  },

  computed: {
    ...mapState(['UI']),
  },

  methods: {
    toLogin: function() {
      this.$router.replace({
        name: 'login',
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/registry/index.vue